import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TagsFilterState {
  appliedTags: Record<string, string[]>;
}

const initialState: TagsFilterState = {
  appliedTags: {},
};

const tagsFilterSlice = createSlice({
  name: 'tagsFilter',
  initialState,
  reducers: {
    updateTagsFilter: (state, action: PayloadAction<{ tagId: string; value: string }>) => {
      const { tagId, value } = action.payload;
      const currentValues = state.appliedTags[tagId] || [];
      if (currentValues.includes(value)) {
        state.appliedTags[tagId] = currentValues.filter(v => v !== value);
      } else {
        state.appliedTags[tagId] = [...currentValues, value];
      }
    },
    clearTagsFilter: state => {
      state.appliedTags = {};
    },
  },
});

export const { updateTagsFilter, clearTagsFilter } = tagsFilterSlice.actions;
export default tagsFilterSlice.reducer;
